@if(selected_menu(); as menu){
    <section class="menu-viewer" [class.menu]="menu.type == 'Manual'">

        @if(menu.type != 'Manual'){
            <div class="menu-back p-5 rounded" paint="plan-fg">
                <button mat-stroked-button paint="plan-bg" (click)="selected_menu.set(null)"><mat-icon>list</mat-icon> <span>MENU LIST</span></button>
            </div>
        }
    
        @switch(menu.type){
            @case ('PDF'){
                <iframe [src]="((menu.menu_pdf | bucket)??'') | safe: 'resource'"></iframe>
            }

            @case ('Url'){
                <iframe [src]="menu.menu_url??'' | safe:'resource'"></iframe>
            }

            @default {
                <h1 class="menu-title-actions package-text font-extrabold">
                    <span class="menu-title-text">{{menu.title}}</span>
                    <span class="menu-back">
                        <button mat-stroked-button (click)="selected_menu.set(null)" paint="plan-bg">
                            <mat-icon iconPositionStart>list</mat-icon>
                            <span>MENU LIST</span>
                        </button>
                    </span>
                </h1>
                @for(submenu of menu.categories || []; track $index){
                    <div class="submenu">
                        <h3 class="submenu-heading m-0 package-text font-bold">{{submenu.title}}</h3>
            
                        <div class="menu-descriptions">
                            @for(description of submenu.descriptions||[]; track $index){
                                <p light class="submenu-description m-0 less package-text">{{description}}</p>
                            }
                        </div>
            
                        @for(item of submenu.items || []; track $index){
                            <div class="menu-item">
                                <ng-container *ngTemplateOutlet="item.details.length == 1 && !item.details[0].size ? menuitemSingle : menuitemMulti; context: { $implicit: item }"></ng-container>
                            </div>
                        }
            
                        <div class="menu-notes">
                            @for(note of submenu.notes||[]; track $index){
                                <p light class="submenu-footnote m-0 less package-text">{{note}}</p>
                            }
                        </div>
            
                        <mat-divider></mat-divider>
                    </div>
                }
            }
        }
        <!-- <mat-divider style="margin: 0 25%;"></mat-divider> -->
    </section>
} @else {
    <section class="menu-selector">
        @for(store of stores(); track store._id; let first = $first; let last = $last){
            @if(first && !last){
                <h2 class="store-brand font-bold">{{store.brand}}</h2>
                <p class="store-brand-sub">Choose a menu below depending on the location you are in or want to visit</p>
                <!-- <mat-divider class="header-divider"></mat-divider> -->
            }
            <!-- <h3 *ngIf="stores.length != 1">{{store.name}}</h3> -->
             @for(menu of store.menus; track menu._id || i; let i = $index){
                 <button class="menu-option" (click)="selected_menu.set(menu);">
                     <div class="menu-option-container">
                         <p class="m-0 font-semibold" paint="plan-bg">
                             <span>{{menu.title}}</span>
                             <span class="menu-options">
                                @for(option of menu_options()[menu._id]||[]; track option.value){
                                    <mat-icon class="menu-option-icon" [svgIcon]="'menu:'+option.icon" [matTooltip]="option.key + ' options available'"></mat-icon>
                                }
                             </span>
                         </p>
                         <div class="row-skipper"></div>
                         <small class="font-light">{{store.name}}</small>
                     </div>
                 </button>
             }
            @if(!last){
                <mat-divider class="store-divider"></mat-divider>
            }
        }
    </section>
}




<ng-template #menuitemSingle let-item>
    <h3 class="m-0 menu-item-heading font-semibold">
        <span class="menu-item-name">{{item.name}}</span>
        <span class="menu-item-price">
            @let price = item.details[0].price;
            @let isNum = price | isNumber;
            {{isNum ? (price | currency) : price}}
        </span>
    </h3>

    <p class="m-0 menu-item-description less font-light">
        {{item.description}}
    </p>
</ng-template>

<ng-template #menuitemMulti let-item>
    <h3 class="m-0 menu-item-heading font-semibold">
        <span class="menu-item-name">{{item.name}}</span>
        <!-- <span class="menu-item-price">{{item.details[0].price}}</span> -->
    </h3>

    <p class="m-0 menu-item-description less font-light">
        {{item.description}}
    </p>

    @for(detail of item.details||[]; track $index){
        <p class="m-0 menu-detail">
            <span class="menu-detail-size less">{{detail.size}}</span>
            <span class="menu-detail-price font-semibold">{{parsePrice(detail.price)}}</span>
        </p>
    }
</ng-template>